
const Modal = require('app/ui/Modal');
const GraphQLQuery = require('app/graphql/Query');
const AutocompleteList = require('app/ui/list/Autocomplete');

const FormFactory = require('app/restaurant/analyse/product/FormFactory');

class TempCreateModal {
    defaultOptions() {
        return {
            'id': window.uniqid(),
            'title': "title",
            'suppliers': [],
            'ranges': [],
            'units': [],

            'autocompleteTriggerMinLength': 3,
            'nbAutocompleteResult': 10,
            'onSubmitDispose': true,
            'onSubmit': function(data){},
            'onClose': function(event){},
            'onShown': function(event){}
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmit = this.onSubmit.bind(this);

        this.typingTimer=null;
        this.initialize();
    }

    initialize() {
        var self = this;


        this.build();
    }

    build(){

        this.$content = $('<div/>')
        .addClass('restaurant-analyse-product-create-modal');

        this.modal = new Modal({
            'id': this.settings.id,
            'title': this.settings.title,
            'showFooter': false,
            'content' : this.$content,
            'modalSize': "xl",

            'onShown':this.settings.onShown,
            'onClose':this.settings.onClose,
        })

        this.$content
        .append(this.buildForm());

        this.modal.show();
    }

    buildForm(){
        var self = this;

        this.$form = $('<form/>')
        .addClass('restaurant-analyse-product-create-form')
        .on('submit',this.onSubmit);

        this.$btnSubmit = $('<button/>')
        .attr('type','button')
        .addClass('btn btn-success')
        .append(window.translate("add"))
        .on('click',function(){
            self.$form.trigger('submit');
        });

        let formFactory = new FormFactory(this.settings);

        formFactory.fillForm(this.$form);

        this.$form.append(
            $('<div/>')
            .addClass('d-flex justify-content-center mt-2')
            .append(this.$btnSubmit)
        );
        return this.$form;
    }

    dispose(){
        this.modal.dispose();
    }

    onSuccess(data){
        this.dispose();
        this.settings.onSuccess(data.productAssociation);
    }

    isValid(){
        var formObject = this.$form[0];
        var validity = formObject.checkValidity();
        this.$form.addClass('was-validated');

        if(validity === false){
            return false;
        }
        return true;
    }

    onSubmit(event){
        event.preventDefault();
        event.stopPropagation();
        if(!this.isValid()){
            return;
        }

        let data = window.serializeForm(this.$form);

        this.settings.onSubmit(data);
        if(this.settings.onSubmitDispose){
            this.dispose();
        }
    }

    onClickBtnCancel(event){
        if(this.settings.onClose){
            this.settings.onClose();
        }
    }
}

module.exports = TempCreateModal;

